// == Import npm
import React from 'react';
import { Link } from 'react-router-dom';

// == Import
import './footer.scss';

const anneeActuelle = new Date().getFullYear()

// == Composant
const Footer = () => (
  <footer className="footer">
    <Link to="/mentions-légales">Mentions Légales</Link>
    <p className="footer-text">&copy; Guillaume Sanchez - Tous droits réservés 2020-{anneeActuelle}</p>
    <nav className="footer-reseaux">
      <a className="footer-reseaux-link" target="_blank" href="https://www.linkedin.com/in/guillaume-sanchez/"><i className="fab fa-linkedin"></i></a>
      <a className="footer-reseaux-link" target="_blank" href="https://github.com/Guillaume-Sanchez"><i className="fab fa-github-square"></i></a>
    </nav>
  </footer>
);

// == Export
export default Footer;